import * as trackActions from '../pages/track/trackActions'
import * as albumActions from '../pages/album/albumActions'
import * as artistActions from '../pages/artist/artistActions'
import * as playlistActions from '../pages/playlist/playlistActions'
import { redirectMobile } from './redirectMobileAction'
import * as storyActions from '../pages/story/storyActions'

export const redirectMiddleware = store => next => action => {
	switch (action.type) {
		case trackActions.GET_TRACK_SUCCESS:
		case trackActions.GET_TRACK_ERROR:
		case albumActions.GET_ALBUM_SUCCESS:
		case albumActions.GET_ALBUM_ERROR:
		case artistActions.GET_ARTIST_SUCCESS:
		case artistActions.GET_ARTIST_ERROR:
		case playlistActions.GET_PLAYLIST_SUCCESS:
		case playlistActions.GET_PLAYLIST_ERROR:
		case storyActions.GET_STORY_SUCCESS:
		case storyActions.GET_STORY_ERROR:
			redirectMobile()(store.dispatch, store.getState)
			break
		default:
	}
	next(action)
}



// WEBPACK FOOTER //
// ./src/redirectmobile/redirectMobileMiddleware.js